<template>
  <div class='container-fluid'>
    <div class='row justify-content-md-center'>
      <div class="col-md-4 cold-md-offset-4">
        <img src="../../static/images/teams-login.png" alt="webstreak logo" class="center-block img-fluid">
        <div class="alert alert-danger" v-if="error">{{ error }}</div>
        <form @submit.prevent="login">
          <div class="form-group">
            <input v-model='email' type="email" class="form-control" aria-describedby="emailHelp" placeholder="Enter email" required autofocus>
          </div>
          <div class="form-group">
            <input v-model='password' type="password" class="form-control" placeholder="Password" required>
          </div>
          <button type="submit" class="btn">Sign In</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      error: false
    }
  },

  computed: {
    ...mapGetters(['currentUser'])
  },

  created () {
    this.checkLogin()
  },

  updated () {
    this.checkLogin()
  },

  methods: {

    checkLogin () {
      this.pushToHome()
    },

    login () {
      if (process.env.USE_SSO === false) {
        // email: test@webstreak.com password: password
        localStorage.token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE1MzUzODA2OTgsImV4cCI6MTU2NjkxNjY5OCwiYXVkIjoid3d3LmV4YW1wbGUuY29tIiwic3ViIjoianJvY2tldEBleGFtcGxlLmNvbSIsInVzZXJfaWQiOiIzIiwiZW1haWwiOiJ0ZXN0QHdlc2J0cmVhay5jb20iLCJyb2xlcyI6IlthZG1pbl0ifQ.ZDgkvno2Pxf-A6JlmpEqXi64TYqKv4wROQ7RWCv-RjQ'
        this.$store.commit('login')
        this.error = false
        this.pushToHome()
      } else {
        this.$http.post('/user_token', {auth: {email: this.email, password: this.password}})
          .then(response => this.loginSuccessful(response))
          .catch((e) => this.loginFailed(e))
      }
    },

    loginSuccessful (response) {
      var token = response.data.jwt
      if (!token) {
        this.loginFailed()
        return
      }
      localStorage.token = token
      this.error = false
      this.$store.dispatch('loadUser', 'login')
      this.$store.dispatch('loadUsers')
      this.$store.dispatch('loadTeams')
    },

    loginFailed (e) {
      console.log(e)
      this.error = 'Login failed'
      delete localStorage.token
    },

    pushToHome () {
      if (this.currentUser) {
        if (this.currentUser.defaultMailboxId) {
          var id = this.currentUser.defaultMailboxId
          this.$router.push('/inboxes/' + id)
        } else {
          this.$router.push('/boards')
        }
      }
    }
  }
}
</script>

<style scoped>
  div#app .container-fluid {
    background-image: url('../../static/images/login-background.png');
    height: 100vh;
    background-size: cover;
  }
  img {
    margin-top: 80px;
    margin-bottom: 20px;
  }
  button {
    width: 200px;
    border-radius: 20px;
    background-color: #434343;
    color: #fff;
  }
  button:hover {
    background-color: #6F6F6F;
  }
  input {
    width: 300px;
    margin: 0 auto;
    border-radius: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue